/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { combineReducers } from 'redux'

import mfa from './mfa'
import token from './token'

import type { ReduxState } from '@/types/redux'
import type { State } from './types'

export type { State }

export default combineReducers<State>({
  // @ts-ignore I don't understand the type errors here, they're strange
  mfa,
  // @ts-ignore
  token,
})

const _getMfa = (state: State) => state.mfa

export const getMfa = (state: ReduxState) => _getMfa(state.auth)
